import { NgModule, ModuleWithProviders } from '@angular/core';
import { UiHelperService } from './services/ui-helper.service';

@NgModule({
  imports: [
  ],
  declarations: [],
  providers:
    [
    ],
  exports: []
})
export class UiHelperModule {
  static forRoot(): ModuleWithProviders<UiHelperModule> {
    return {
      ngModule: UiHelperModule,
      providers: [
        UiHelperService
      ]
    }
  }

}
